import { handleMessages } from './util';

const handleGroupLabelInput = ($trigger, $input) => {
  const label = $input.val();
  $input.val('');
  return label;
};

let SortableClass = null;
const initSortableElement = (html, sortableGroup) => {
  if (SortableClass === null) {
    import(/* webpackChunkName: "sortablejs" */ 'sortablejs').then(({ Sortable }) => {
      SortableClass = Sortable;
      initSortableElement(html, sortableGroup);
    });
    return;
  }

  // eslint-disable-next-line no-new
  new SortableClass(html, {
    group: sortableGroup,
    animation: 150,
    ghostClass: 'dragging',
    revertClone: false,
  });
};

const checkLabels = (label) => {
  let isValid = true;
  const $groupLabels = $('[data-container-group-label]');
  $groupLabels.each((index, groupLabel) => {
    if ($(groupLabel).text() === label) {
      isValid = false;
    }
  });
  return isValid;
};

const $groupItemLists = $('[data-draggable-item-type="positions-list"]');
if ($groupItemLists.length) {
  $groupItemLists.each((i) => {
    initSortableElement($groupItemLists[i], 'items');
  });
}

const $groupsParent = $('[data-draggable-groups-parent]');
if ($groupsParent.length) {
  initSortableElement($groupsParent[0], 'groups');
}

const $standalonePositionList = $('[data-standalone-position-list]');
if ($standalonePositionList.length) {
  initSortableElement($standalonePositionList[0], 'stand-alone');
}

// eslint-disable-next-line prefer-arrow-function
$(document).on('click', '[data-edit-view-duplicate-control]', function () {
  const $targetEl = $(this).closest('[data-container-draggable-position]');
  const $clone = $($targetEl[0].cloneNode(true));
  $clone.attr('data-source-position-id', $clone.attr('data-position-id'));
  $clone.removeAttr('data-position-id');
  $clone.insertAfter($targetEl);
});

// eslint-disable-next-line prefer-arrow-function
$(document).on('click', '[data-edit-view-delete-group]', function () {
  const $targetEl = $(this).closest('[data-container-draggable-group]');
  if ($('[data-container-draggable-group]').length === 2) {
    const itemList = `
        <ul class="container-edit-view__draggable-list"
            data-standalone-position-list></ul>
      `;
    $(itemList).insertAfter($targetEl);
    const $positions = $('[data-container-draggable-position]');
    $positions.each((i) => {
      $('[data-standalone-position-list]').append($positions[i]);
    });
    initSortableElement($('[data-standalone-position-list]')[0], 'items');
  }
  $targetEl.remove();
});

// eslint-disable-next-line prefer-arrow-function
$(document).on('click', '[data-edit-view-delete-position]', function () {
  const $targetEl = $(this).closest('[data-container-draggable-position]');
  $targetEl.remove();
});

// eslint-disable-next-line prefer-arrow-function
$(document).on('click', '[data-edit-view-duplicate-group]', function () {
  const $targetEl = $(this).closest('[data-container-draggable-group]');
  const $revealLabel = $('[data-group-copy-label]');
  $revealLabel.removeClass('hide');
  $('[data-group-label-form]').on('submit', function (event) {
    event.preventDefault();
    const label = handleGroupLabelInput($(this), $('[data-group-label-input]'));
    if (!checkLabels(label)) {
      $('[data-label-alert]').removeClass('hide');
    } else {
      const $clone = $($targetEl[0].cloneNode(true));
      $clone.find('[data-container-group-label]').text(label);
      $clone.removeAttr('data-group-id');
      $clone.find('[data-draggable-item-type="position"]').each((i, el) => {
        $(el).attr('data-source-position-id', $(el).attr('data-position-id'));
        $(el).removeAttr('data-position-id');
      });
      $clone.insertAfter($targetEl);
      if ($clone.hasClass('is-open')) {
        $clone.find('[data-container-group-content]').toggle();
        $clone.removeClass('is-open');
      }
      initSortableElement($clone.find('[data-draggable-item-type="positions-list"]')[0], 'items');
      $revealLabel.addClass('hide');
      $('[data-label-alert]').addClass('hide');
      $('[data-group-label-form]').foundation('close');
    }
  });
});

$(document).on('click', '[data-edit-view-add-group]', () => {
  const $revealLabel = $('[data-group-add-label]');
  const $groupsContainer = $('[data-draggable-groups-parent]');
  const $lastGroupsContainerItem = $groupsContainer
    .children('[data-standalone-position-list],[data-container-group]')
    .last();
  const isStandAlone = $groupsContainer.children().first().data('standalone-position-list');
  $revealLabel.removeClass('hide');
  $('[data-group-label-form]').on('submit', function (event) {
    event.preventDefault();
    const label = handleGroupLabelInput($(this), $('[data-group-label-input]'));
    if (!checkLabels(label)) {
      $('[data-label-alert]').removeClass('hide');
    } else {
      const $template = $('[data-container-group-template]');
      const $clone = $($template[0].cloneNode(true));
      $clone.find('[data-container-group-label]').text(label);
      $clone.removeAttr('data-container-group-template');
      $clone.removeClass('hide');
      $clone.insertAfter($lastGroupsContainerItem);
      if (typeof isStandAlone !== 'undefined' && isStandAlone !== false) {
        const $positions = $($lastGroupsContainerItem.children().get().reverse());
        $positions.each((i) => {
          $clone.find('[data-draggable-item-type="positions-list"]').prepend($positions[i]);
        });
        $lastGroupsContainerItem.remove();
      }
      initSortableElement($clone.find('[data-draggable-item-type="positions-list"]')[0], 'items');
      $revealLabel.addClass('hide');
      $('[data-label-alert]').addClass('hide');
      $('[data-group-label-form]').foundation('close');
    }
  });
});

$(document).on('click', '[data-edit-view-rename-group]', function () {
  const $targetEl = $(this).closest('[data-container-draggable-group]');
  const $revealLabel = $('[data-group-change-label]');
  $revealLabel.removeClass('hide');
  const $input = $('[data-group-label-input]');
  const groupLabel = $targetEl.find('[data-container-group-label]').text();
  $input.val(groupLabel);
  $('[data-group-label-form]').on('submit', function (event) {
    event.preventDefault();
    const label = handleGroupLabelInput($(this), $('[data-group-label-input]'));
    if (label !== groupLabel && !checkLabels(label)) {
      $('[data-label-alert]').removeClass('hide');
    } else {
      $targetEl.find('[data-container-group-label]').text(label);
      $revealLabel.addClass('hide');
      $('[data-label-alert]').addClass('hide');
      $('[data-group-label-form]').foundation('close');
    }
  });
});

$('[data-group-label-form]').on('closed.zf.reveal', () => {
  $('[data-group-label-form]').unbind('submit');
  $('[data-group-change-label]').addClass('hide');
  $('[data-group-add-label]').addClass('hide');
  $('[data-group-copy-label]').addClass('hide');
  $('[data-label-alert]').addClass('hide');
});

$(document).on('click', '[data-save-cart-edits-url]', () => {
  const url = $('[data-save-cart-edits-url]').data('save-cart-edits-url');
  const $HTMLSource = $('[data-draggable-groups-parent]');
  const payload = [];
  let hasGroups = false;
  $HTMLSource.children().each((i, child) => {
    if ($(child).data('draggable-item-type') === 'group') {
      hasGroups = !hasGroups ? !hasGroups : hasGroups;
      const groupData = {
        id: $(child).data('group-id'),
        label: $(child).find('[data-container-group-label]').text(),
        positions: [],
      };
      $(child).find('[data-draggable-item-type="positions-list"]')
        .children('[data-draggable-item-type="position"]').each((j, position) => {
          groupData.positions.push({
            item_id: $(position).data('item-id'),
            position_id: $(position).data('position-id'),
            source_position_id: $(position).data('source-position-id'),
          });
        });
      payload.push(groupData);
    } else {
      $(child).find('[data-draggable-item-type="position"]').each((j, position) => {
        payload.push({
          item_id: $(position).data('item-id'),
          position_id: $(position).data('position-id'),
          source_position_id: $(position).data('source-position-id'),
        });
      });
    }
  });
  $.ajax({
    url,
    data: JSON.stringify({ has_groups: hasGroups, payload }),
    contentType: 'application/json',
    method: 'POST',
    headers: { 'X-CSRFToken': $HTMLSource.data('csrf-token') },
  }).then(handleMessages).then((json) => {
    window.location.href = json.redirect;
  });
});
